// eslint-disable-next-line import/prefer-default-export
export const FIREBASE_FUNCTION_URL = process.env.REACT_APP_FIREBASE_FUNCTION_URL
